export const serviceOfferings = [
  {
    icon: 'ri-hard-drive-3-line',
    title: 'IBM Power Systems',
    tagline: 'Enterprise compute, engineered for uptime',
    desc: 'We design, deploy, and maintain IBM Power environments running AIX, IBM i, and Linux. From capacity planning and LPAR design to OS upgrades and performance tuning, our engineers keep your mission-critical workloads fast and available.',
    points: ['Power9 / Power10 architecture planning', 'AIX & IBM i support and patching', 'LPAR, VIOS and workload balancing', 'Performance tuning and capacity reviews'],
  },
  {
    icon: 'ri-database-2-line',
    title: 'Storage & Data Protection',
    tagline: 'Your data, always available',
    desc: 'Storage is the backbone of every business. We architect SAN, NAS, and flash tiers, then layer on the replication, snapshot, and backup strategy that lets you recover from anything in minutes rather than days.',
    points: ['SAN / NAS design and migration', 'Flash and hybrid tiering', 'Replication and site failover', 'Backup, retention and bare-metal restore'],
  },
  {
    icon: 'ri-stack-line',
    title: 'Virtualization',
    tagline: 'Consolidate, simplify, save',
    desc: 'In an increasingly changing technology environment, virtualization is the logical choice to consolidate any site running multiple older servers. Fewer boxes, less power, less cost, and a whole lot less to manage.',
    points: ['Server consolidation assessments', 'Hypervisor implementation and health checks', 'VM migration and P2V projects', 'High availability and DR clustering'],
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: 'IT Security',
    tagline: 'Protection that pays for itself',
    desc: 'Ensuring your company data security is a top priority. With the constant threat of hackers, ransomware, and viruses, having the best protection saves you money and headaches down the road.',
    points: ['Vulnerability and risk assessments', 'Endpoint and network defense in depth', 'Identity, MFA and access hardening', 'Security policy and compliance guidance'],
  },
  {
    icon: 'ri-cloud-line',
    title: 'Cloud Services',
    tagline: 'Access your information anywhere',
    desc: 'ACU-COMP offers the latest in infrastructure technology with the Cloud, a tool many companies now use to access their information from anywhere, anytime. We help you choose the right mix of on-prem and cloud.',
    points: ['Cloud readiness and migration planning', 'Microsoft 365 and Azure workloads', 'Hybrid cloud and identity integration', 'Cost optimization and governance'],
  },
  {
    icon: 'ri-server-line',
    title: 'Networking & Hosting',
    tagline: 'Connectivity without the drama',
    desc: 'ACU-COMP provides a variety of services to accommodate your company needs, covering everything from basic website hosting to fully managed data center and network infrastructure.',
    points: ['LAN / WAN and firewall management', 'Business continuity and connectivity design', 'Website and application hosting', 'Wi-Fi design and coverage surveys'],
  },
  {
    icon: 'ri-clipboard-line',
    title: 'IT Assessments',
    tagline: 'Know exactly where you stand',
    desc: 'Some of the biggest and most frustrating equipment problems for a company usually stem from IT issues. Computing issues and errors slow down production, so we find them before your team feels them.',
    points: ['Infrastructure and asset audits', 'Hardware lifecycle and refresh planning', 'Business continuity gap analysis', 'Budget and roadmap reporting'],
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Managed IT Support',
    tagline: 'A helpdesk that actually answers',
    desc: '24/7 monitoring and a North America-based helpdesk that responds fast. We handle the day-to-day so your internal team can stay focused on the work that grows the business.',
    points: ['Proactive monitoring and alerting', 'Remote and on-site helpdesk', 'Patch and update management', 'Vendor and warranty coordination'],
  },
];

export const engagementSteps = [
  {
    step: '01',
    icon: 'ri-chat-search-line',
    title: 'Discovery Call',
    desc: 'We start by understanding your business, your downtime tolerance, and the outcomes that actually matter to you.',
  },
  {
    step: '02',
    icon: 'ri-file-search-line',
    title: 'Assessment',
    desc: 'Our engineers audit your compute, storage, network, and security posture, then document what we find in plain English.',
  },
  {
    step: '03',
    icon: 'ri-route-line',
    title: 'Roadmap & Quote',
    desc: 'You get a prioritized plan with clear pricing, expected business impact, and a realistic timeline. No pressure, no jargon.',
  },
  {
    step: '04',
    icon: 'ri-rocket-2-line',
    title: 'Implement & Support',
    desc: 'We execute the project with minimal disruption, then stay on as your ongoing IT partner with monitoring and support.',
  },
];

export const supportHighlights = [
  { icon: 'ri-time-line', value: 'Same-day', label: 'On-site response' },
  { icon: 'ri-award-line', value: '20+ yrs', label: 'IBM platform experience' },
  { icon: 'ri-lock-2-line', value: '99.9%', label: 'Uptime delivered' },
  { icon: 'ri-user-voice-line', value: 'One team', label: 'Dedicated to your account' },
];